import { addDaysToDate, formatDate, isValidDateString } from '@travelata-libs/utils';
import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toCount, toText } from './values';

const ISO_DATE_FORMAT = 'yyyy-MM-dd';

const URL_DATE_PATTERN = /^(\d{2})\.(\d{2})\.(\d{4})$/;

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const DAYS_FROM_TODAY_PATTERN = /^[1-9]\d{0,2}$/;

function toIsoDate(value: unknown, today: Date): string {
  const text = toText(value);

  const urlDate = URL_DATE_PATTERN.exec(text);
  if (urlDate) {
    const [, day, month, year] = urlDate;
    const isoDate = `${year}-${month}-${day}`;
    return isValidDateString(isoDate) ? isoDate : '';
  }

  if (ISO_DATE_PATTERN.test(text)) {
    return isValidDateString(text) ? text : '';
  }

  if (DAYS_FROM_TODAY_PATTERN.test(text)) {
    return formatDate(addDaysToDate(today, Number(text)), ISO_DATE_FORMAT);
  }

  return '';
}

export function checkInDateRange(
  query: QueryObject,
  today: Date = new Date(),
): Pick<SearchCriteriaParams, 'checkInDateRange'> | null {
  const from = toIsoDate(query.dateFrom, today);
  if (!from) {
    return null;
  }

  const range: SearchCriteriaParams['checkInDateRange'] = { from, to: toIsoDate(query.dateTo, today) || from };

  const daysFlexible = toCount(query.daysFlexible);
  if (daysFlexible) {
    range.daysFlexible = daysFlexible;
  }

  return { checkInDateRange: range };
}
